import React from "react";
import { Breadcrumb } from "antd";

export default (props) => {
  const { crumb } = props;
  const breadcrumbItemLoop = data => data.map((cb, i) => <Breadcrumb.Item key={cb + i}>{cb}</Breadcrumb.Item>);
  return (
    <div style={{
      borderBottom: "1px solid #dfdfdf",
      marginBottom: "20px",
      padding: "0px 10px 10px"
    }}
    >
      <Breadcrumb separator=">">
        {breadcrumbItemLoop(crumb)}
      </Breadcrumb>
    </div>);
};



// WEBPACK FOOTER //
// ./src/components/breadcrumb/index.js